var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "data-display": _vm.display,
      "list": _vm.questionsMetadata.widgets,
      "move": _vm.checkMove,
      "draggable": false,
      "component-data": _vm.getComponentData(),
      "group": {
        name: 'question'
      },
      "force-fallback": true,
      "scroll-sensitivity": 200
    }
  }, _vm._l(_vm.questionsMetadata.widgets, function (question, i) {
    return _c('div', {
      key: question.name + i,
      staticClass: "draggable"
    }, [question.display === 'question' ? _c('v-card', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('v-card-text', [_c('div', {
      staticClass: "text--primary"
    }, [_c('widget-component', {
      attrs: {
        "widgetMetadata": question
      }
    }), _c('widget-component', {
      staticStyle: {
        "margin-top": "-3px"
      }
    }), _c('v-card', [_c('v-card-title', {
      staticClass: "text-overline"
    }, [_c('h4', [_vm._v("Answer")])]), _c('v-card-text', [_c('widget-component', {
      attrs: {
        "widgetMetadata": question.preview
      }
    })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
      attrs: {
        "color": "red",
        "text": ""
      },
      on: {
        "click": function ($event) {
          return _vm.onClickRemove(question);
        }
      }
    }, [_vm._v("Remove")]), _c('v-btn', {
      attrs: {
        "color": "blue",
        "text": ""
      },
      on: {
        "click": function ($event) {
          return _vm.onClickAdd(question);
        }
      }
    }, [_vm._v("Add")])], 1)], 1)], 1)])], 1) : _vm._e()], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }